<div class="page-content__container">
  <div class="mat-table-container--bordered" [class.min-height]="matDataSource?.data?.length === 0">
    @if (config.hasFilter) {
      <div class="mat-table-filter">
        <div fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="16px">
          @if (config?.hasSelect) {
            <div fxFlex="0 0 0">
              <button mat-button class="select-all" (click)="selection()">
                <mat-icon inline=true>{{(isAllSelected) ? 'clear' : 'playlist_add_check'}}</mat-icon>
                {{(isAllSelected) ? 'Unselect' :'Select'}} all
              </button>
            </div>
          }
          
            <mat-chip-grid #chipGrid>
              @for (chip of filterChipset; track chip) {
                <mat-chip-row (removed)="removeFilter(chip)">
                  {{chip}}
                  <button matChipRemove><mat-icon>cancel</mat-icon></button>
                </mat-chip-row>
              }
              <input [matChipInputFor]="chipGrid" style="display: none;" />
              <button mat-button (click)="openFilterDialog()" class="mat-table-filter__add-filter">
                @if (filterChipset?.length > 0 || !config?.hasSearch) {
                  <span>
                    <mat-icon inline="true">add</mat-icon>Add Filter
                  </span>
                }
                @if (filterChipset?.length === 0 && config?.hasSearch) {
                  <span>
                    <mat-icon inline="true">search</mat-icon>Search Here
                  </span>
                }
              </button>
              @if (config?.table === 'Commercial_Orders_Table') {
                <mat-chip-row
                  [highlighted]="includeArchivedOrders"
                  [ngClass]="{'mat-table__archive-orders': includeArchivedOrders, 'mat-table__no-archive-orders': !includeArchivedOrders}"
                  (click)="includeArchiveOrders()"
                  >
                  <mat-icon class="archive-icon" fontSet="material-icons-outlined">inventory_2</mat-icon>  Include Archived Orders@if (includeArchivedOrders) {
                  <button matChipRemove (click)="excludeArchiveOrders($event)"><mat-icon class="remove-icon">cancel</mat-icon></button>
                }
              </mat-chip-row>
              @if (isBuTgi() && drawInNextNDays !== null) {
                <mat-chip-row
                  [highlighted]="isDrawInNextNDaysActive"
                  [ngClass]="{'mat-table__draw-active': isDrawInNextNDaysActive, 'mat-table__draw-inactive': !isDrawInNextNDaysActive}"
                  (click)="activateDrawInNextNDays()">
                  <mat-icon class="draw-icon" fontSet="material-icons-outlined">schedule</mat-icon>
                  Draw in next {{ drawInNextNDays }} days
                  @if (isDrawInNextNDaysActive) {
                    <button matChipRemove (click)="deactivateDrawInNextNDays($event)"><mat-icon class="remove-icon">cancel</mat-icon></button>
                  }
                </mat-chip-row>
              }
              @if (isBuTgi() && soExpiringInNextNDays !== null) {
                <mat-chip-row
                  [highlighted]="isSoExpiringActive"
                  [ngClass]="{'mat-table__so-expiring-active': isSoExpiringActive, 'mat-table__so-expiring-inactive': !isSoExpiringActive}"
                  (click)="activateSoExpiring()">
                  <mat-icon class="so-icon" fontSet="material-icons-outlined">warning</mat-icon>
                  SO expiring in next {{ soExpiringInNextNDays }} days
                  @if (isSoExpiringActive) {
                    <button matChipRemove (click)="deactivateSoExpiring($event)"><mat-icon class="remove-icon">cancel</mat-icon></button>
                  }
                </mat-chip-row>
              }
              @if (isBuTgi()) {
                <mat-chip-row
                  [highlighted]="includeStandingOrders"
                  [ngClass]="{'mat-table__standing-orders': includeStandingOrders, 'mat-table__no-standing-orders': !includeStandingOrders}"
                  (click)="includeStandingOrdersOnly()"
                  >
                  <mat-icon class="is-so-icon">repeat</mat-icon> Standing Orders Only
                  @if (includeStandingOrders) {
                    <button matChipRemove (click)="excludeStandingOrdersOnly($event)"><mat-icon class="remove-icon">cancel</mat-icon></button>
                  }
                </mat-chip-row>
              }
            }
          </mat-chip-grid>
        
      </div>
    </div>
  }
  <div [ngClass]="{ 'table-responsive': config.isResponsive }" [class]="config?.outerDiVClass" class="clindx-table"
    id="tableOuterCover">
    <table class="stickyTable" [ngClass]="config?.tableClass" mat-table  [dataSource]="matDataSource"
      matSort matSortDisableClear (matSortChange)="sortData($event)"
      multiTemplateDataRows>
      <caption></caption>
      @for (column of config?.columnList; track column.columnName) {
        <ng-container matColumnDef="{{column.columnName}}">{{column.hasSort}}
          @if (column.cellTemplate) {
            <th mat-header-cell scope="col" *matHeaderCellDef [ngClass]="column.classThName">
            {{column.columnDisplayValue}} </th>
            <td mat-cell *matCellDef="let element" [ngClass]="column.classTdName" [ngStyle]="{'font-weight': returnBool(element?.isRead)}"
              [style.color]="element[config?.rowCondition?.field] ? config?.rowCondition?.color ? config?.rowCondition?.color : '#DC3545' : 'inherit'">
              @if (config.isResponsive) {
                <span class="mobile-label">{{column.columnDisplayValue}}:</span>
              }
              <ng-template [ngTemplateOutletContext]="{
              $implicit: element
            }" [ngTemplateOutlet]="column.cellTemplate">
              </ng-template>
            </td>
          }
          @if (!column.cellTemplate) {
            <th mat-header-cell scope="col" *matHeaderCellDef mat-sort-header
              [class.noSorting]="column.hasSort === false" [ngClass]="column?.classThName"
              [style.width]="!(isScreenSmall|async) && column?.columnWidth">
              {{column.columnDisplayValue}}
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="column.classTdName" [ngStyle]="{'font-weight': returnBool(element?.isRead)}"
              [style.color]="element[config?.rowCondition?.field] ? config?.rowCondition?.color ? config?.rowCondition?.color : '#DC3545' : 'inherit'">
              @if (config?.isResponsive) {
                <span class="mobile-label">{{column?.columnDisplayValue}}:</span>
              }
              @if (!column?.dataAccessor) {
                <span>
                  {{element[column.columnName]}}
                </span>
              }
              @if (column?.dataAccessor) {
                <span>
                  {{column?.dataAccessor(element)}}
                </span>
              }
            </td>
          }
        </ng-container>
      }
      @if (isBuTgiorVcd() && config?.panelColumnList) {
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [ngStyle]="{'font-weight': returnBool(element?.isRead)}"
            [attr.colspan]="displayedColumns.length">
            <div [ngClass]="config?.tableWidth ? config.tableWidth : 'expanded-detail'"
              [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'">
              @if (element.isExpanded) {
                <table mat-table [dataSource]="element?.results" class="clindx-table">
                  <caption></caption>
                  @for (column of config?.panelColumnList; track column.columnName) {
                    <ng-container matColumnDef="{{column.columnName}}">
                      @if (column.cellTemplate) {
                        <th mat-header-cell scope="col" *matHeaderCellDef [ngClass]="column?.classThName"
                        [style.width]="!(isScreenSmall|async) && column?.columnWidth">{{column.columnDisplayValue}}</th>
                        <td mat-cell *matCellDef="let element" [ngClass]="column?.classTdName"
                        [ngStyle]="{'font-weight': returnBool(element?.isRead)}" [style.color]="element[config?.rowCondition?.field] ?
                        config?.rowCondition?.color ? config?.rowCondition?.color : '#DC3545' : 'inherit'">
                          @if (config.isResponsive) {
                            <span class="mobile-label">{{column.columnDisplayValue}}:</span>
                          }
                        <ng-template [ngTemplateOutletContext]="{
                          $implicit: element
                        }" [ngTemplateOutlet]="column.cellTemplate">
                          </ng-template>
                        </td>
                      }
                      @if (!column.cellTemplate) {
                        <th mat-header-cell scope="col" *matHeaderCellDef [ngClass]="column?.classThName"
                          [style.width]="!(isScreenSmall|async) && column?.columnWidth">
                          {{column.columnDisplayValue}}
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="column?.classTdName"
                          [ngStyle]="{'font-weight': returnBool(element?.isRead)}" [style.color]="element[config?.rowCondition?.field] ?
                          config?.rowCondition?.color ? config?.rowCondition?.color : '#DC3545' : 'inherit'">
                          @if (config?.isResponsive) {
                            <span class="mobile-label">{{column.columnDisplayValue}}:</span>
                          }
                          <span [ngClass]="element?.rowStyles?.class && element?.rowStyles?.class ? element?.rowStyles?.class : ''" >{{element[column.columnName]}}</span>
                          <span class="trendingIcon">@if (column.columnName == 'result' && element.isGraph) {
                            <mat-icon class="icon" (click)="fetchTestDetails(element)">trending_up</mat-icon>
                          }</span>
                        </td>
                      }
                    </ng-container>
                  }
                  <tr mat-header-row
                    *matHeaderRowDef="element.results && addColumnConditional(element.results)">
                  </tr>
                  <tr mat-row
                    *matRowDef="let row; columns: element.results && addColumnConditional(element.results);">
                  </tr>
                </table>
              }
            </div>
          </td>
        </ng-container>
      }
      @if (!isBuTgiorVcd() && config?.panelColumnList) {
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [ngStyle]="{'font-weight': returnBool(element?.isRead)}"
            [attr.colspan]="displayedColumns.length">
            <div [ngClass]="config?.tableWidth ? config.tableWidth : 'expanded-detail'"
              [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'">
              @if (element.isExpanded) {
                <table mat-table [dataSource]="element?.performedTestDto" class="clindx-table">
                  <caption></caption>
                  @for (column of config?.panelColumnList; track column.columnName) {
                    <ng-container matColumnDef="{{column.columnName}}">
                      @if (column.cellTemplate) {
                        <th mat-header-cell scope="col" *matHeaderCellDef [ngClass]="column?.classThName"
                        [style.width]="!(isScreenSmall|async) && column?.columnWidth">{{column.columnDisplayValue}}</th>
                        <td mat-cell *matCellDef="let element" [ngClass]="column?.classTdName"
                        [ngStyle]="{'font-weight': returnBool(element?.isRead)}" [style.color]="element[config?.rowCondition?.field] ?
                        config?.rowCondition?.color ? config?.rowCondition?.color : '#DC3545' : 'inherit'">
                          @if (config.isResponsive) {
                            <span class="mobile-label">{{column.columnDisplayValue}}:</span>
                          }
                        <ng-template [ngTemplateOutletContext]="{
                          $implicit: element
                        }" [ngTemplateOutlet]="column.cellTemplate">
                          </ng-template>
                        </td>
                      }
                      @if (!column.cellTemplate) {
                        <th mat-header-cell scope="col" *matHeaderCellDef [ngClass]="column?.classThName"
                          [style.width]="!(isScreenSmall|async) && column?.columnWidth">
                          {{column.columnDisplayValue}}
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="column?.classTdName"
                          [ngStyle]="{'font-weight': returnBool(element?.isRead)}" [style.color]="element[config?.rowCondition?.field] ?
                          config?.rowCondition?.color ? config?.rowCondition?.color : '#DC3545' : 'inherit'">
                          @if (config?.isResponsive) {
                            <span class="mobile-label">{{column.columnDisplayValue}}:</span>
                          }
                          <span [ngClass]="element?.rowStyles?.class && element?.rowStyles?.class ? element?.rowStyles?.class : ''" >{{element[column.columnName]}}</span>
                        </td>
                      }
                    </ng-container>
                  }
                  <tr mat-header-row
                    *matHeaderRowDef="element.performedTestDto && addColumnConditional(element.performedTestDto)">
                  </tr>
                  <tr mat-row
                    *matRowDef="let row; columns: element.performedTestDto && addColumnConditional(element.performedTestDto);">
                  </tr>
                </table>
              }
            </div>
          </td>
        </ng-container>
      }
      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="6" class="norecord">
          @if ((filterChipset?.length > 0 || !config?.hasSearch)) {
            <div><span>No records
            found.</span></div>
          } @else {
            <span class="search-link"><a class="orangeColor" role="button" tabindex="0" 
            (click)="openFilterDialog()" (keydown.enter)="openFilterDialog()">Search here</a> for the {{config?.hasSearch?.searchText}}</span>
          }
        </mat-footer-cell>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: config.hasStickyHeader"></tr>
      <tr (click)="config?.isRowClickable; rowClick.emit(i)" mat-row
        *matRowDef="let row; columns: displayedColumns; let i=dataIndex;" class="mat-row-detail"
        [class.expanded-detail-row]="config?.panelColumnList" [class.student-expanded-row]="row.isExpanded"
        [ngClass]="{ 'highlight': row[config?.rowCondition?.field]}" id="{{'specimenRow'+i}}"
        [class.highlightRow]="curentFocusingIndex === i && isAltIpressed" tabindex={{999+i}}>
      </tr>
      <tr mat-footer-row *matFooterRowDef="['noData']"
        [ngClass]="{'hide':!(matDataSource !== null && matDataSource?.data?.length === 0 || matDataSource?.filteredData?.length === 0)}">
      </tr>
      @if (config?.panelColumnList) {
        <tr mat-row [class.expandable-row]="!row.isExpanded" *matRowDef="let row; columns: ['expandedDetail']"></tr>
      }
    </table>
  <mat-paginator [ngStyle]="{display: config?.pagination && matDataSource?.data?.length > 0 ? 'block' : 'none'}"
      [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [pageIndex]="pageIndex"
      (page)="onPage($event)" showFirstLastButtons>
    </mat-paginator>